import React, { FC } from "react";

// UI
import {
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  AlertProps,
} from "../Alert/Alert";
import { Expire } from "../Expire/Expire";
import { As } from "@chakra-ui/react";

import { CircleCheck } from "../Icons/CircleCheck";
import { CircleInfo } from "../Icons/CircleInfo";
import { CircleXmark } from "../Icons/CircleXmark";
import { AlertTriangle } from "../Icons/AlertTriangle";

interface Props extends AlertProps {
  title?: string;
  icon?: As;
  expireDelay?: number;
}

const STATUS_TO_ICON: {
  [key in AlertProps["status"]]: As;
} = {
  success: CircleCheck,
  info: CircleInfo,
  error: CircleXmark,
  warning: AlertTriangle,
  loading: AlertTriangle,
};

export const GenericAlert: FC<Props> = ({
  children,
  title,
  status,
  icon,
  expireDelay,
  ...rest
}) => {
  const Icon: Props["icon"] = icon || STATUS_TO_ICON[status];
  return (
    <Expire delay={expireDelay} transition="collapse" offsetY="50px">
      <Alert status={status} variant="left-accent" {...rest}>
        <AlertIcon as={Icon} />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{children}</AlertDescription>
      </Alert>
    </Expire>
  );
};
